import * as CL from '@design-system/component-library';
import { t } from '../../../common/i18n/index.js';
import { getSortOrderOptions } from '../../ProductGridCoCo/ProductGridSortCoCo.js';
import type { SortType } from '../../ProductGridCoCo/ProductGridSortCoCo.js';

import './DeviceSelectionSortCoCo.scss';

interface DeviceSelectionSortCoCoProps {
  selectedValue: SortType;
  onChange: (sort: SortType) => void;
}

export const DeviceSelectionSortCoCo = ({ selectedValue, onChange }: DeviceSelectionSortCoCoProps) => (
  <CL.Dropdown
    className="of-device-selection-sort-coco"
    items={getSortOrderOptions()}
    i18n_dropdown_ariaLabel={t.BIIR('Sort order')}
    selectedValue={selectedValue}
    onValueChange={element => onChange(element.dataset.value as SortType)}
  />
);
